export default __webpack_public_path__ + "static/media/03_photo.0879ac57.jpg";